var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}],ref:"container",staticClass:"obj-container",attrs:{"element-loading-text":"加载中","element-loading-spinner":"el-icon-loading","element-loading-background":"rgba(0, 0, 0, 0.8)"}})
}
var staticRenderFns = []

export { render, staticRenderFns }